import { useMutation } from "@tanstack/react-query";
import { analyticsApi } from "./analytics.api";

export const usePostHubspotEvent = () => {
  return useMutation({
    mutationFn: async ({
      event,
      props = {},
    }: { event: string; props?: Record<string, unknown> }) =>
      analyticsApi.postHubspotEvent(event, props),
  });
};

export const usePostHubspotProperty = () => {
  return useMutation({
    mutationFn: async (property: Record<string, string | number | Date>) =>
      analyticsApi.postHubspotProperty(property),
  });
};
